<template>
  <div>
    <div slot="reference">
        <div style="display:inline" v-if="!now">在</div>
        <div style="display:inline;font-weight:bold;" v-if="!now">{{excutionTime}}</div>
        <div style="display:inline" v-if="!now">后发送</div>
        <div style="display:inline;color:blue;" v-if="!now">{{name}}</div>
        <div style="display:inline" v-if="!now">{{type}}</div>
        <div v-if="now">{{excutionTime}}</div>
      </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    time: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      timer: null,
      excutionTime: null,
      showTime: {
        second: 0,
        minute: 0,
        hour: 0,
        day: 0
      },
      now: false,
      serverTime: 0
    };
  },
  mounted() {
    const requestStart = Date.now();
    this.$ajax({
      method: 'GET',
      url: '/system/getCurrentTime'
    }).then((res) => {
      const serverTimestamp = moment(res.data, 'YYYY-MM-DD HH:mm:ss').valueOf();
      const requestCost = Date.now() - requestStart;
      this.serverTime = serverTimestamp + requestCost;
    }).catch(() => {
      this.serverTime = Date.now();
    }).finally(() => {
      this.excutionTime = this.getDownTime(this.time);
      this.timer = setInterval(() => {
        this.serverTime += 1000;
        this.excutionTime = this.getDownTime(this.time);
      }, 1000);
    });
  },
  methods: {
    getDownTime(execTime) {
      const format = this.formatter(moment(execTime).unix() - parseInt(this.serverTime / 1000, 10));
      return format;
    },
    formatter(time) {
      let str = '';
      if (time <= 0) {
        this.now = true;
        str = `正在发送${this.name},${this.type}`;
        // console.warn(`${time}---${str}`);
        return str;
      }
      this.cleanTime();
      this.showTime.second = time;
      if (this.showTime.second >= 60) {
        this.showTime.second = time % 60;
        this.showTime.minute = parseInt(time / 60, 10);
        if (this.showTime.minute >= 60) {
          this.showTime.hour = parseInt(this.showTime.minute / 60, 10);
          this.showTime.minute = this.showTime.minute % 60;
          if (this.showTime.hour >= 24) {
            this.showTime.day = parseInt(this.showTime.hour / 24, 10);
            this.showTime.hour = this.showTime.hour % 24;
          }
        }
      }
      if (this.showTime.day > 0) {
        str += `${this.showTime.day}天`;
      }
      str += `${this.showTime.hour}小时${this.showTime.minute}分钟${this.showTime.second}秒 `;
      // console.warn(`${time}---${str}`);
      return str;
    },
    cleanTime() {
      this.showTime.second = 0;
      this.showTime.minute = 0;
      this.showTime.hour = 0;
      this.showTime.day = 0;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/case/interval.vue